window.Reverb = window.Reverb || {};

// Data bindings that can be used on DOM elements to
// achieve certain reusable behaviors, such as buttons
// that hide themselves, or that load content via Ajax.
Reverb.DomPatterns = (function () {
  function bindToggleInputOnChange() {
    $(document).on('change', '[data-toggle-input-on-change]', function () {
      const toBeToggled = $($(this).data('toggle-input-on-change'));

      toggleElements(toBeToggled);
    });
  }

  function bindDisableInputToggle() {
    $(document).on('click', '[data-disable-input]', function () {
      const toBeToggled = $($(this).data('disable-input'));

      toggleElements(toBeToggled);
    });
  }

  function toggleElements(toBeToggled) {
    toBeToggled.each((i, e) => {
      const el = $(e);
      if (el.prop('disabled')) {
        el.prop('disabled', false);
      } else {
        el.prop('disabled', true);
      }
    });
  }

  function bindSlideUpTargetOnClick() {
    $(document).on('click', '[data-slide-up-target]', function () {
      const elementToHide = $(this).data('slide-up-target');
      $(elementToHide).slideUp();
    });
  }

  function bindSlideDownTargetOnClick() {
    $(document).on('click', '[data-slide-down-target]', function () {
      const elementToShow = $(this).data('slide-down-target');
      $(elementToShow).slideDown();
    });
  }

  function hideOnClick() {
    $(document).on('click', '[data-hide-on-click]', function () {
      $(this).hide();
    });
  }

  function openContainer(trigger, wrapper) {
    trigger.attr('data-toggle-container-state', 'open');
    wrapper.slideDown(150);
  }

  function closeContainer(trigger, wrapper) {
    trigger.attr('data-toggle-container-state', 'closed');
    wrapper.slideUp(150);
  }

  function toggleElementOnClick() {
    $(document).on('click', '[data-toggle-element]', function (e) {
      const trigger = $(this);
      const wrapper = $(trigger.data('toggle-element'));

      e.preventDefault();

      if (!wrapper) {
        return;
      }

      if (wrapper.is(':visible')) {
        closeContainer(trigger, wrapper);
      } else {
        openContainer(trigger, wrapper);
      }
    });
  }

  function hideElementOnClick() {
    $(document).on('click', '[data-hide-element-on-click]', function () {
      $($(this).data('hide-element-on-click')).hide();
    });
  }

  function removeElementOnClick() {
    $(document).on('click', '[data-remove-element-on-click]', function () {
      $($(this).data('remove-element-on-click')).remove();
    });
  }

  function showElementOnClick() {
    $(document).on('click', '[data-show-on-click]', function () {
      $($(this).data('show-on-click')).show();
    });
  }

  function handleSlideouts() {
    $(document).on('click', '[data-slideout]', toggleElement);
    $('input:checked[data-slideout][data-show-if-checked][type=checkbox]').each((index, checkbox) => {
      toggleElement({ target: checkbox });
    });
  }

  function toggleElement(e) {
    const clickedElement = $(e.target);
    const allowClicks = clickedElement.data('slideout-allow-clicks');

    if (!clickedElement.is(':input') && !allowClicks) {
      e.preventDefault();
    }

    if (clickedElement.data('saved')) {
      const text = clickedElement.text();
      const saved = clickedElement.data('saved');

      clickedElement.data('saved', text).text(saved);
    }

    // allows us to wrap elements in data-slideout
    const elemToShow = $(clickedElement.closest('[data-slideout]').data('slideout'));


    const elemToAutofocus = $(clickedElement.data('autofocus-element'));

    if (clickedElement.data('slideout-text')) {
      if (elemToShow.is(':visible')) {
        clickedElement.text(clickedElement.data('slideout-text-original'));
      } else {
        clickedElement.data('slideout-text-original', clickedElement.text());
        clickedElement.text(clickedElement.data('slideout-text'));
      }
    }

    Reverb.UI.slideOut(elemToShow, elemToAutofocus);
  }

  function stripHtml(dirtyText) {
    let cleanText;


    const container = document.createElement('div');

    container.innerHTML = dirtyText;
    cleanText = container.textContent || container.innerText;

    return cleanText;
  }

  return {
    init() {
      hideOnClick();
      hideElementOnClick();
      removeElementOnClick();
      showElementOnClick();
      handleSlideouts();
      toggleElementOnClick();
      bindSlideUpTargetOnClick();
      bindSlideDownTargetOnClick();
      bindDisableInputToggle();
      bindToggleInputOnChange();
    },
    stripHtml,
  };
}());


$(() => {
  Reverb.DomPatterns.init();
});
